import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useWebsiteData } from './hooks/useWebsiteData';
import WebsiteRenderer from './WebsiteRenderer';

const generateCssVariables = (config) => {
    if (!config) return {};
    const variables = {};
    if (config.primary) variables['--primary'] = config.primary;
    if (config.secondary) variables['--secondary'] = config.secondary;
    if (config.topBar?.bgColor) variables['--topbar-bg-color'] = config.topBar.bgColor;
    if (config.topBar?.textColor) variables['--topbar-text-color'] = config.topBar.textColor;
    if (config.header?.bgColor) variables['--header-bg-color'] = config.header.bgColor;
    if (config.header?.textColor) variables['--header-text-color'] = config.header.textColor;
    if (config.footer?.bgColor) variables['--footer-bg-color'] = config.footer.bgColor;
    if (config.footer?.textColor) variables['--footer-text-color'] = config.footer.textColor;
    return variables;
};

// This page acts just like LiveAgentWebsite, but forces the Details View!
const LivePackageDetailsPage = ({ companyId }) => {
  // Grab the package ID from the browser URL (e.g., /packages/123 -> 123)
  const { packageId } = useParams(); 
  
  const { data, isLoading, isError } = useWebsiteData(companyId);

  const cssVariables = useMemo(() => {
    return data?.style ? generateCssVariables(data.style) : {};
  }, [data]);

  if (isLoading) return <div className="loading-spinner">Loading Details...</div>;
  if (isError || !data?.layout) return <div>Website not found.</div>;

  return (
    <div style={cssVariables} className="live-website-container">
       <WebsiteRenderer 
          layout={data.layout} 
          branding={data.branding} 
          companyId={companyId}
          headerMenu={data.headerMenu} 
          footerData={data.footerData}
          mode="live" // 👈 Explicit Mode
          // 👇 FORCE THE RENDERER INTO DETAILS MODE AND PASS THE URL ID
          viewState={{ name: 'package-details', params: { packageId: packageId } }}
       />
    </div>
  );
};

export default LivePackageDetailsPage;